import { Row, Table } from '../types'

export const deepCopyTable = (table: Table): Table => {
  return structuredClone(table)
}

export const deepCopyRow = (row: Row): Row => {
  return structuredClone(row)
}
